/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Filter_ClientInputs */

const en_dashboard_filter_client = /** @type {(inputs: Dashboard_Filter_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by client`)
};

const pt_br2_dashboard_filter_client = /** @type {(inputs: Dashboard_Filter_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por cliente`)
};

/**
* | output |
* | --- |
* | "Filter by client" |
*
* @param {Dashboard_Filter_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_filter_client = /** @type {((inputs?: Dashboard_Filter_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Filter_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_filter_client(inputs)
	return pt_br2_dashboard_filter_client(inputs)
});